// extracted by mini-css-extract-plugin
module.exports = {"TitleUnderText":"_2zKwr8394-8UeFzSo_WwxQ"};